import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationServiceApi, UserCredentialsDto } from '@api/authentication';
import { AuthProvider } from '@domain/authentication';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutingKeys, LoadingIndicatorState, ToastDuration, ToastService } from '@shared';
import { firstValueFrom } from 'rxjs';
import { AccountStateService } from '../../services/account-state.service';
import { AccountBaseComponent } from '../base';

@Component({
	selector: 'app-registration-fusion-password',
	templateUrl: './account-fusion-password.component.html',
	styleUrls: ['../../account.scss']
})
export class AccountFusionPasswordComponent extends AccountBaseComponent {
	public showPassword = false;

	public constructor(
		private authenticationApi: AuthenticationServiceApi,
		private accountStateSerivce: AccountStateService,
		private translateService: TranslateService,
		private authProvider: AuthProvider,
		private toastService: ToastService,
		private loadingIndicator: LoadingIndicatorState,
		public navController: NavController,
		public router: Router
	) {
		super(navController, router);
	}

	public get helperText(): string {
		const content = this.isRegistration() ? 'registration.content.password' : 'reset.content.password';
		return this.translateService.instant(content);
	}

	public toggleFieldTextType() {
		this.showPassword = !this.showPassword;
	}

	public async onSubmit(formValues: { fieldFormControl: string }): Promise<void> {
		if (!this.isFormValid()) {
			return;
		}

		try {
			this.loadingIndicator.setIsLoading(true);
			const values = this.accountStateSerivce.getFormValues();
			const authMethod = await this.authProvider.getAuthenticationMethod();

			const isAuthenticated = await firstValueFrom(
				this.authenticationApi.login(
					values.connectionId,
					new UserCredentialsDto({
						AuthenticationMethod: authMethod,
						Password: formValues.fieldFormControl,
						Userid: values.username
					})
				)
			);

			this.loadingIndicator.setIsLoading(false);

			const route = this.isRegistration() ? AppRoutingKeys.urlPathRegistration : AppRoutingKeys.urlPathResetPin;

			if (isAuthenticated) {
				await this.navController.navigateForward(`${route}/${AppRoutingKeys.urlPathRegistrationPin}`);
			} else {
				// TODO: Add UI for this error, once API is done
				throw new Error('User is already authenticated');
			}
		} catch (error) {
			this.loadingIndicator.setIsLoading(false);

			this.toastService.presentError(
				this.translateService.instant('registration.errorMessages.auth'),
				ToastDuration.Slow
			);
		}
	}
}
